export const uk = {
    'add-minus-keywords-pack-success': 'Набор успешно создан'
};
